import { useState } from "react";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import CampoNumber from "../Campo/CampoNumber";
import { MetaCalendario } from "../../model/PlanoDeTrabalho/PlanoAplicacao";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { MetaFisica } from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import CampoSelect from "../Campo/CampoSelect";

type Props = {
  refMeta?: MetaCalendario;
  closeModal: Function;
  list: MetaCalendario[];
  setList: Function;
  listaMetas: MetaFisica[];
  index?: number;
};

const ModalMetaCalendario = ({
  refMeta,
  closeModal,
  list,
  setList,
  listaMetas,
  index,
}: Props) => {
  const anoAtual = new Date(Date.now()).getFullYear();
  const [metaFisica, setMetaFisica] = useState(refMeta?.metaFisica || 0);
  const [etapa, setEtapa] = useState(refMeta?.etapa || 1);
  const [fase, setFase] = useState(refMeta?.fase || 1);
  const [ano, setAno] = useState(refMeta?.ano || anoAtual);
  const [jan, setJan] = useState(refMeta?.meses[0] || 0);
  const [fev, setFev] = useState(refMeta?.meses[1] || 0);
  const [mar, setMar] = useState(refMeta?.meses[2] || 0);
  const [abr, setAbr] = useState(refMeta?.meses[3] || 0);
  const [mai, setMai] = useState(refMeta?.meses[4] || 0);
  const [jun, setJun] = useState(refMeta?.meses[5] || 0);
  const [jul, setJul] = useState(refMeta?.meses[6] || 0);
  const [ago, setAgo] = useState(refMeta?.meses[7] || 0);
  const [sete, setSet] = useState(refMeta?.meses[8] || 0);
  const [outu, setOut] = useState(refMeta?.meses[9] || 0);
  const [nov, setNov] = useState(refMeta?.meses[10] || 0);
  const [dez, setDez] = useState(refMeta?.meses[11] || 0);

  return (
    <form className={styles.formModal}>
      <h2>Criar Aplicação de Recurso</h2>

      <CampoSelect
        title="Meta Fisica"
        setter={setMetaFisica}
        value={metaFisica}
      >
        {listaMetas &&
          listaMetas.map((metaFisica, index) => (
            <option value={index} key={index}>
              {`${metaFisica.etapa}.${
                metaFisica.fase
              } - ${metaFisica.descricao.substring(0, 70)}${
                metaFisica.descricao.length > 70 ? "..." : ""
              }`}
            </option>
          ))}
      </CampoSelect>

      <div className={styles.gridCampos}>
        <div className={styles.gridCampos}>
          <CampoNumber title="Etapa" setter={setEtapa} value={etapa} min={0} />

          <CampoNumber title="Fase" setter={setFase} value={fase} min={0} />
        </div>
        <CampoNumber
          title="Ano"
          min={anoAtual}
          max={anoAtual + 100}
          setter={setAno}
          value={ano}
        />
      </div>
      <hr className={styles.separador} />
      <div className={styles.gridCampos}>
        <div className={styles.gridCampos}>
          <CampoNumber
            title="Jan"
            step={0.25}
            setter={setJan}
            value={jan}
            min={0}
          />
          <CampoNumber
            title="Fev"
            step={0.25}
            setter={setFev}
            value={fev}
            min={0}
          />
        </div>
        <div className={styles.gridCampos}>
          <CampoNumber
            title="Mar"
            step={0.25}
            setter={setMar}
            value={mar}
            min={0}
          />
          <CampoNumber
            title="Abr"
            step={0.25}
            setter={setAbr}
            value={abr}
            min={0}
          />
        </div>

        <div className={styles.gridCampos}>
          <CampoNumber
            title="Mai"
            step={0.25}
            setter={setMai}
            value={mai}
            min={0}
          />
          <CampoNumber
            title="Jun"
            step={0.25}
            setter={setJun}
            value={jun}
            min={0}
          />
        </div>
        <div className={styles.gridCampos}>
          <CampoNumber
            title="Jul"
            step={0.25}
            setter={setJul}
            value={jul}
            min={0}
          />
          <CampoNumber
            title="Ago"
            step={0.25}
            setter={setAgo}
            value={ago}
            min={0}
          />
        </div>

        <div className={styles.gridCampos}>
          <CampoNumber
            title="Set"
            step={0.25}
            setter={setSet}
            value={sete}
            min={0}
          />
          <CampoNumber
            title="Out"
            step={0.25}
            setter={setOut}
            value={outu}
            min={0}
          />
        </div>
        <div className={styles.gridCampos}>
          <CampoNumber
            title="Nov"
            step={0.25}
            setter={setNov}
            value={nov}
            min={0}
          />
          <CampoNumber
            title="Dez"
            step={0.25}
            setter={setDez}
            value={dez}
            min={0}
          />
        </div>
      </div>
      <hr className={styles.separador} />
      {!refMeta && (
        <input
          type="submit"
          value="+ Adicionar Aplicação"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            if (VerificaForm(e.currentTarget.form)) {
              const item: MetaCalendario = {
                metaFisica: metaFisica,
                etapa: etapa,
                fase: fase,
                ano: ano,
                meses: [
                  jan,
                  fev,
                  mar,
                  abr,
                  mai,
                  jun,
                  jul,
                  ago,
                  sete,
                  outu,
                  nov,
                  dez,
                ],
              };
              addList({
                item,
                list,
                setList,
              });
              closeModal();
            }
          }}
        />
      )}
      {refMeta !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Aplicação"
            className={styles.editBtn}
            onClick={(e) => {
              e.preventDefault();
              if (VerificaForm(e.currentTarget.form)) {
                const item: MetaCalendario = {
                  metaFisica: metaFisica,
                  etapa: etapa,
                  fase: fase,
                  ano: ano,
                  meses: [
                    jan,
                    fev,
                    mar,
                    abr,
                    mai,
                    jun,
                    jul,
                    ago,
                    sete,
                    outu,
                    nov,
                    dez,
                  ],
                };
                editList({
                  item,
                  setList,
                  list,
                  index,
                });

                closeModal();
              }
              closeModal();
            }}
          />
          <input
            type="submit"
            value="Remover Aplicação"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalMetaCalendario;
